import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
// Note: We remove Nav, Container, and Card imports since they are handled in MasterListPage
// import { Nav, Container, Card } from "react-bootstrap"; 
import EnquiryLogPage from "./EnquiryLog"; 
import EnquiryJunkPage from "./EnquiryJunk"; 
import EnquiryDraftPage from "./EnquiryDraft"; 

// Define the valid tab types
type TabType = "log" | "junk" | "draft";

// Map the URL param to a more readable type for the component
const tabMap: Record<string, TabType> = {
  enquiry_log: "log", // URL parameter
  junk: "junk",       // URL parameter
  draft: "draft",     // URL parameter
};

const ProductEnquiryPage: React.FC = () => {
  // Use useParams to get the 'tab' dynamic segment from the route
  const { tab: urlTabParam } = useParams<{ tab: string }>();
  // We no longer need 'navigate' or 'handleTabChange' here, 
  // as the tab components themselves (which render MasterListPage) will handle navigation on click.
  
  const type: "product" = "product"; // The type is fixed for this page

  // Determine the active tab based on the URL param
  const activeTab: TabType = tabMap[urlTabParam || "enquiry_log"] || "log";

  // Determine which component to render
  const TabContent = useMemo(() => {
    // Pass the fixed 'type' prop to all tab components
    switch (activeTab) {
      case "log":
        // Ensure you pass the correct `activeTab` value expected by the tab component logic
        return <EnquiryLogPage type={type} />; 
      case "junk":
        return <EnquiryJunkPage type={type} />;
      case "draft":
        return <EnquiryDraftPage type={type} />;
      default:
        return <EnquiryLogPage type={type} />;
    }
  }, [activeTab]);

  return (
    <>
      {/* Simply render the content component determined by the URL */}
      {TabContent}
    </>
  );
};

export default ProductEnquiryPage;
